<template>
  <v-card
    class="c analytics-simple-statistic"
    :class="{'is-clickable': clickable}"
    :ripple="clickable"
  >
    <v-card-text @click="onClick">
      <div class="value" :style="`${color === 'error' ? 'color: #FF5252;' : ''}`">
        <template v-if="type === 'number'">
          {{ value }}
        </template>
        <template v-else>
          {{ value }}{{ suffix }}
        </template>
      </div>
      <div class="label">
        <v-subheader>{{ label }}</v-subheader>
      </div>
    </v-card-text>
    <div v-if="clickable" class="click-icon">
      <v-icon>{{ icon }}</v-icon>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SimpleStatistic',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'normal',
    },
    type: {
      type: String,
      default: 'number',
    },
    suffix: {
      type: String,
      default: '',
    },
    decimals: {
      type: Number,
      default: 0,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'open_in_new',
    },
  },

  data() {
    return {
      startVal: 0,
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.startVal = oldVal;
    },
  },

  methods: {
    onClick() {
      this.$emit('item-click');
    },
  },
};
</script>
